
/**
 * PropertySliderField - Reusable range slider for garden object properties
 *
 * @param {string} label - Field label
 * @param {number} value - Current value
 * @param {function} onChange - Callback(newValue) when value changes
 * @param {number} min - Minimum value
 * @param {number} max - Maximum value
 * @param {number} step - Step increment
 * @param {string} unit - Optional unit to display (e.g., 'cm', '%')
 * @param {boolean} disabled - Whether field is disabled
 */
const PropertySliderField = ({
  label,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  unit = '',
  disabled = false,
}) => {
  return (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">
        {label}
      </label>
      <div className="flex items-center gap-2">
        <input
          type="range"
          value={value ?? min}
          onChange={(e) => onChange(parseFloat(e.target.value))}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          className="flex-1 h-2 accent-emerald-500
            disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <span className="text-sm text-gray-700 min-w-[3rem] text-right">
          {value ?? min}{unit}
        </span>
      </div>
    </div>
  );
};

export default PropertySliderField;
